import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { APP_CONFIG, AppConfig } from '../../../app.config'; 
@Injectable({
  providedIn: 'root'
})
export class UserParameterService {
  private httpClient = inject(HttpClient);
  private router = inject(Router);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly apiBaseUrl: string;

  public errorEmail = false;
  public errorGender = false;
  public errorName = false;
  public errorZipcode = false;
  public errorPhone = false;
  public errorDeleteReason = false;
  public errorCommentMaxLength = false;
  public errorDeleteBadId = false;
  public errorBadPassword = false;
  public errorBadUpdate = false;
  public successMessage = false;

  constructor() {
    this.apiBaseUrl = `${this.config.api}/api`;
  }

  public resetMessages() {
    this.errorEmail = false;
    this.errorGender = false;
    this.errorName = false;
    this.errorZipcode = false;
    this.errorPhone = false;
    this.errorDeleteReason = false;
    this.errorCommentMaxLength = false;
    this.errorDeleteBadId = false;
    this.errorBadPassword = false;
    this.errorBadUpdate = false;
    this.successMessage = false;
  }

  public changeLogin(login: string, password: string): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/updateLogin`, { "newLogin": login, "password": password });
  }

  public changePassword(newPassword: string, password: string): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/updatePassword`, { "newPassword": newPassword, "password": password });
  }

  public changeInfo(gender: string | undefined, name: string | undefined, zipcode: string | undefined): Observable<any> {
    return this.httpClient.get(`${this.apiBaseUrl}/preferences`).pipe(
      concatMap((response: any) => {
        if (!response) {
          return EMPTY;
        }
        const profile = response;
        profile.user.usageName = name;
        profile.user.title = gender;
        profile.user.zipcode = zipcode;
        return this.httpClient.post(`${this.apiBaseUrl}/preferences`, profile);
      })
    );
  }

  public changeEmail(email: string | undefined, password: string): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/updateEmail`, { "newEmail": email, "password": password });
  }

  public changePhone(prePhone: string | undefined, phone: string | undefined): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/updatePhone`, { 
      "newCode": { "phoneCode": prePhone, "contryCode": "" }, 
      "newPhone": phone, 
      "newPhoneCode": prePhone 
    });
  }

  public changeNewsletter(newsInfo: boolean | undefined, newsletter: boolean | undefined): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/preferences/subscriptions`, { 
      "newsletter": newsletter, 
      "serviceInfo": newsInfo, 
      "partners": false 
    });
  }

  public changeCurrency(currency: string): Observable<any> {
    return this.httpClient.get(`${this.apiBaseUrl}/preferences`).pipe(
      concatMap((response: any) => {
        if (!response) {
          return EMPTY;
        }
        const profile = response;
        profile.currency = currency;

        return this.httpClient.post(`${this.apiBaseUrl}/preferences`, profile);
      })
    );
  }

  public suppressAccount(reason: string, comment: string, password: string, id: number | undefined): Observable<any> {
    const params = new HttpParams()
      .set('password', window.btoa(password))
      .set('reason', reason)
      .set('comment', comment);

    return this.httpClient.delete(`${this.apiBaseUrl}/users/${id}?${params}`);
  }

  public updateProfile(request: any): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/updateProfile`, request);
  }
}